<template>
  <Tile
    :title="pluraliseString('Invoice', entries.length)"
    :entries="entries"
    :selected="selected"
    :tooltip="tooltip"
  >
    <div class="q-mt-xs">
      <b style="width: 30px;" class="inline-block">Due:</b> {{ friendlyNumber(figures.amountDue, true) }}
    </div>
    <div class="q-mt-xs">
      <b style="width: 30px;" class="inline-block">Paid:</b> {{ friendlyNumber(figures.amountPaid, true) }}
    </div>
  </Tile>
</template>

<script>
import Tile from 'components/partials/timeline/partials/Tile'
import tileMixin from 'components/partials/timeline/partials/tileMixin'

export default {
  components: {
    Tile
  },
  mixins: [tileMixin],
  computed: {
    figures () {
      const figures = {
        amountDue: 0,
        amountPaid: 0
      }

      for (const ele of this.entries) {
        if (ele.status === 'DRAFT') {
          continue
        }
        figures.amountDue += parseFloat(ele.amount_due || 0)
        figures.amountPaid += parseFloat(ele.amount_paid || 0)
      }

      return figures
    }
  }
}
</script>
